// CapaType-specific validation - Uses generic validation utility
import { createValidation } from '../../../utils/validation';

/**
 * CapaType-specific validation factory
 * This is a thin wrapper around the generic validation utility
 * for backwards compatibility with existing capaType module code
 */
export const createCapaTypeValidation = (fields) => {
  const validation = createValidation(fields);
  
  // Return both generic and specific method names for flexibility
  return {
    schema: validation.schema,
    validateData: validation.validateData, // Generic name for configInit
    validateCapaTypeData: validation.validateData, // Specific name for backwards compatibility
    validateField: validation.validateField
  };
};

// Default export for backwards compatibility
export default createCapaTypeValidation;
